import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'

const DEFAULT_SORT = { label: "Task ID", value: "TaskId" };
const DEFAULT_ORDER = { label: "Ascending", value: "ASC" };

const TaskGroupByContext = createContext();

export const TaskGroupByProvider = ({ children }) => {

    const [selectedOrder, setSelectedOrder] = useState(DEFAULT_ORDER);
    const [selectedSort, setSelectedSort] = useState(DEFAULT_SORT);
    const [selectedOption, setSelectedOption] = useState("None");
    const [selectedGroupBy, setSelectedGroupBy] = useState(null);

    const handleDeleteClick = useCallback(() => {
        setSelectedOption("None");
        setSelectedGroupBy(null);
    }, []);

    const resetGroupBy = handleDeleteClick;

    const contextValues = useMemo(() => ({
        selectedOrder,
        selectedSort,
        selectedOption,
        selectedGroupBy,
        setSelectedOrder,
        setSelectedSort,
        setSelectedOption,
        setSelectedGroupBy,
        handleDeleteClick,
        resetGroupBy,
    }), [selectedOrder, selectedSort, selectedOption, selectedGroupBy, handleDeleteClick]);

    return (
        <TaskGroupByContext.Provider value={contextValues}>
            {children}
        </TaskGroupByContext.Provider>
    );
}

export const useGroupBy = () => useContext(TaskGroupByContext);
